import { notify } from '../utils/notification'
import { parseError, agent, updateSessionObject } from 'utils/api'
import constants from 'constants'
import { push } from 'react-router-redux'
import { getFiscalYearTimestamps } from 'utils/fiscalYear'

export const PARTNERPLANS_GET = 'PARTNERPLANS_GET'
export const PARTNERPLANS_RECEIVED = 'PARTNERPLANS_RECEIVED'
export const PARTNERPLANS_PAGE_RECEIVED = 'PARTNERPLANS_PAGE_RECEIVED'
export const PARTNERPLANS_GET_ERROR = 'PARTNERPLANS_GET_ERROR'
export const PARTNERPLANS_INIT_HTMLCONTENT = 'PARTNERPLANS_INIT_HTMLCONTENT'
export const PARTNERPLANS_SET_SELECTEDPLAN = 'PARTNERPLANS_SET_SELECTEDPLAN'
export const PARTNERPLANSTATUS_SAVE_REQUEST = 'PARTNERPLANSTATUS_SAVE_REQUEST'
export const PARTNERPLANSTATUS_SAVE_ERROR = 'PARTNERPLANSTATUS_SAVE_ERROR'
export const PARTNERPLANSTATUS_SAVE_COMPLETE = 'PARTNERPLANSTATUS_SAVE_COMPLETE'

const fetching = type => ({
  type,
})

const fetchingerror = type => ({
  type,
})

const partnerPlansReceive = partnerPlans => ({
  type: PARTNERPLANS_RECEIVED,
  partnerPlans,
})

const partnerPlansPageContentReceive = partnerPlanHTMLPage => ({
  type: PARTNERPLANS_PAGE_RECEIVED,
  partnerPlanHTMLPage,
})

const selectedPlan = plan => ({
  type: PARTNERPLANS_SET_SELECTEDPLAN,
  plan,
})

const initHtmlContent = type => ({
  type,
})

const savePartnerPlanStatus = () => ({
  type: PARTNERPLANSTATUS_SAVE_REQUEST,
})

const savePartnerPlanStatusComplete = result => ({
  result,
  type: PARTNERPLANSTATUS_SAVE_COMPLETE,
})

const mapPartnerPlans = (result) => {
  const partnerPlans = result.map(partner => ({
    rowId: partner.rowId,
    employeeId: partner.employee_id,
    loginName: partner.loginname,
    // partnerId: partner.PartnerId,
    name: partner.partner_name.trim(),
    year: partner.year,
    fy: partner.year,
    interimCounsellee: partner.InterimCounsellee,
    interimCounselleeComments: partner.InterimCounselleeComments,
    interimCounsellor: partner.InterimCounsellor,
    interimCounsellorComments: partner.InterimCounsellorComments,
    interimAgreedDate: partner.InterimAgreedDate,
    finalCounselleeAssessment: partner.FinalCounselleeAssessment,
    finalCounselleeComments: partner.FinalCounselleeComments,
    finalCounsellorAssessment: partner.FinalCounsellorAssessment,
    finalCounsellorComments: partner.FinalCounsellorComments,
    finalAgreedDate: partner.FinalAgreedDate,
    planStatus: partner.PlanStatus,
    lastModifiedBy: partner.LastModifiedBy,
    lastModifiedDate: partner.LastModifiedDate,
    planAgreedDate: partner.PlanAgreedDate,
    planSubmittedDate: partner.PlanSubmittedDate,
    planUploadedDate: partner.PlanUploadedDate,
    interimDate: partner.InterimDate,
    finalDate: partner.FinalDate,
    cpEmpId: partner.Counselling_Partner_Employee_Id,
    cpEmail: partner.Counselling_Partner_Email,
    cpName: partner.Counselling_Partner_Name,
    mlEmpId: partner.Market_Leader_Employee_Id,
    mlEmail: partner.Market_Leader_Email,
    mlName: partner.Market_Leader_Name,
    blEmpId: partner.Business_Leader_Employee_Id,
    blEmail: partner.Business_Leader_Email,
    blName: partner.Business_Leader_Name,
    cilEmpId: partner.Client_Industry_Leader_Employee_Id,
    cilEmail: partner.Client_Industry_Leader_Email,
    cilName: partner.Client_Industry_Leader_Name,
    bucooEmpId: partner.Business_Coo_Employee_Id,
    bucooEmail: partner.Business_Coo_Email,
    bucooName: partner.Business_Coo_Name,
    oplEmpId: partner.Offering_Portfolio_Leader_Employee_Id,
    oplEmail: partner.Offering_Portfolio_Leader_Email,
    oplName: partner.Offering_Portfolio_Leader_Name,
    olEmpId: partner.Offering_Leader_Employee_Id,
    olEmail: partner.Offering_Leader_Email,
    olName: partner.Offering_Leader_Name,
    ceoEmpId: partner.Ceo_Employee_Id,
    ceoEmail: partner.Ceo_Email,
    ceoName: partner.Ceo_Name,
    adminComments: partner.AdminComments,
    planAgreedWithCounsellee: partner.PlanAgreedWithCounsellee,
    interimPlanAgreedWithCounsellee: partner.InterimPlanAgreedWithCounsellee,
    finalPlanAgreedWithCounsellee: partner.FinalPlanAgreedWithCounsellee,
    interimRatingVisibility: partner.InterimRatingVisibility,
    finalRatingVisibility: partner.FinalRatingVisibility,
    assessmentFlag: partner.AssessmentFlag,
  }))
  return partnerPlans
}

export function setSelectedPlan(plan) {
  return (dispatch) => {
    sessionStorage.setItem('SelectedPlan', JSON.stringify(plan))
    dispatch(selectedPlan(plan))
  }
}

export function initHtmlPageContent() {
  return (dispatch) => {
    dispatch(initHtmlContent(PARTNERPLANS_INIT_HTMLCONTENT))
  }
}

export function getPartnerPlans(planView, employeeId, exclExempt = false, year = (getFiscalYearTimestamps().current.year - constants.PARTNERPLAN.PLAN_FILTER_PARTNER_YEAR)) {
  return (dispatch) => {
    dispatch(fetching(PARTNERPLANS_GET))
    agent.PartnerPlans.list(planView, employeeId, year).then((response) => {
      if (exclExempt) {
        const exclExemptData = mapPartnerPlans(response).filter(pp => (pp.planStatus !== constants.PARTNERPLAN.STATUS.EXEMPT))
        dispatch(partnerPlansReceive(exclExemptData))
      } else {
        dispatch(partnerPlansReceive(mapPartnerPlans(response)))
      }
      // dispatch(notify('Successfully load admin centre'))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <editPartnerPlan>: ', description, error)
        dispatch(fetchingerror(PARTNERPLANS_GET_ERROR))
      }
    })
  }
}

export function getMyPartnerPlans(employeeId, year = (getFiscalYearTimestamps().current.year - constants.PARTNERPLAN.PLAN_FILTER_PARTNER_YEAR)) {
  return (dispatch) => {
    dispatch(fetching(PARTNERPLANS_GET))
    agent.PartnerPlans.list(constants.PARTNERPLAN.VIEW.MYPLANS, employeeId, year).then((response) => {
      dispatch(partnerPlansReceive(mapPartnerPlans(response)))
      // dispatch(notify('Successfully load admin centre'))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        dispatch(fetchingerror(PARTNERPLANS_GET_ERROR))
      }
    })
  }
}

export function getPageHtmlContent(libraryName, folderName, employeeId) {
  return (dispatch) => {
    dispatch(fetching(PARTNERPLANS_GET))
    agent.PageHTMLContents.getPageHTMLContents(libraryName, folderName, employeeId)
      .then((result) => {
        dispatch(partnerPlansPageContentReceive(result))
      })
      .catch((rawError) => {
        console.error('Getting page html content error')
        // console.error('getPageHtmlContent error', rawError, rawError.stack, window.location)
        const { error, status, description } = parseError(rawError)
        if (status === constants.ERROR.INTERNAL_SERVER) {
          dispatch(push({
            pathname: '/error',
            search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
          }))
        } else if (status === constants.ERROR.UNAUTHORIZED) {
          updateSessionObject()
        } else {
          dispatch(notify(description))
          dispatch(notify('Error fetching page html content', 'warning'))
          dispatch(push({ pathname: '/' }))
        }
      })
  }
}

/* not used in the app, moved to a console .net app that runs on the script server
export function syncPartnerHierarchyDBUpdate(employeeId) {
  return () => {
    agent.PartnerHierarchy.syncPartnerHierarchyDBUpdate(employeeId)
      .then((result) => {
        console.log('Sync partner hierarchy db update success')
      })
      .catch((rawError) => {
        console.error('Sync partner hierarchy db update error')
        // console.error('syncPartnerHierarchyDBUpdate error', rawError, rawError.stack, window.location)
      })
  }
} */

export const updatePartnerPlanStatus = (employeeId, planYear, planStatus, modifiedBy) => (dispatch) => {
  dispatch(savePartnerPlanStatus())
  agent.PartnerPlans.updateplanstatus(employeeId, planYear, planStatus, modifiedBy).then((response) => {
    dispatch(savePartnerPlanStatusComplete(response))
  }).catch((rawError) => {
    const { error, status, description } = parseError(rawError)
    if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
      dispatch(push({
        pathname: '/error',
        search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
      }))
    } else if (status === constants.ERROR.UNAUTHORIZED) {
      updateSessionObject()
    } else {
      dispatch(notify('Error saving partner plan status, please try again later', 'warning'))
      // console.warn('Err <editPartnerPlan>: ', description, error)
    }
  })
}



// WEBPACK FOOTER //
// ./src/actions/partnerPlans.js